<template>
    <div class="row">
        <div class="col-sm-9">
            <div class="step-detail step-three">
                <h1 class="line-bottom">{{ $t('3. Kies opties en kaders voor uw selectie') }}</h1>
                <p class="row col-sm-10">
                    {{ $t('1. Kies hieronder eerst uw gewenste opties en kaders. Deze worden toegevoegd aan uw selectie. Dit is niet verplicht. Om deze stap over te slaan, klik op de knop “Okee, ga verder” in de rechterkolom')}}
                </p>

                <div class="row e-ext-checks" ref="checks" :style="{ height: $parent.getStepDetailHeight($refs.checks) }">
                    <div class="row">
                        <div class="col-sm-6">
                            <h2>{{ $t('Opties')}}</h2>
                            <div v-for="(optie, key) in orderedOptions" v-if="orderedOptions.length">
                                <ext-checkbox
                                        :type="'optie'"
                                        :name="optie.value"
                                        :price="optie.price"
                                        :current-value="currentValueOption.id"
                                        :info="optie.info[$i18n.locale]"
                                        :value="optie"
                                        :id="optie.id"
                                        :imgSrc="optie.picture"
                                        @kaderOptie="setSelected">
                                    <p>
                                        {{optie.value}}<br>{{optie.info[$i18n.locale]}}
                                    </p>
                                </ext-checkbox>
                            </div>
                            <div v-if="orderedOptions.length == 0">
                                <p>{{ $t('Geen opties gevonden')}}</p>
                            </div>

                        </div>

                        <div class="col-sm-6">
                            <h2 v-if="orderedKaders.length == 0 && orderedKadersGratis.length == 0 && orderedKadersDefault.length == 0 ">{{ $t('Kaders')}}</h2>
                            <h2 v-if="orderedKadersDefault.length">{{ $t('Kaders standaard voorzien')}}</h2>

                            <div v-for="(kader, key) in orderedKadersDefault" v-if="orderedKadersDefault.length">
                                <ext-checkbox v-if="kader.default"
                                              :type="'kaderdefault'"
                                              :name="kader.value"
                                              :price="kader.price"
                                              :info="kader.info[$i18n.locale]"
                                              :id="kader.id"
                                              :current-value="currentValueKaderDefault.id"
                                              :value="kader"
                                              :imgSrc="kader.picture"
                                              :defaultChecked="true"
                                              @kaderOptie="setSelected">
                                    <p>
                                        {{kader.value}}<br>{{kader.info[$i18n.locale]}}
                                    </p>
                                </ext-checkbox>
                            </div>
                            <br>
                            <h2 v-if="orderedKadersGratis.length">{{ $t('Kaders opties (gratis)')}}</h2>
                            <div v-for="(kader, key) in orderedKadersGratis" v-if="orderedKadersGratis.length">
                                <ext-checkbox v-if="kader.price === 0"
                                              :type="'kadergratis'"
                                              :name="kader.value"
                                              :price="kader.price"
                                              :info="kader.info[$i18n.locale]"
                                              :current-value="currentValueKaderGratis.id"
                                              :id="kader.id"
                                              :value="kader"
                                              :imgSrc="kader.picture"
                                              @kaderOptie="setSelected">
                                    <p>
                                        {{kader.value}}<br>{{kader.info[$i18n.locale]}}
                                    </p>
                                </ext-checkbox>
                            </div>
                            <h2 v-if="orderedKaders.length">{{ $t('Kaders opties mits meer prijs')}}</h2>
                            <div v-for="(kader, key) in orderedKaders" v-if="orderedKaders.length">
                                <ext-checkbox v-if="kader.price !== 0"
                                              :type="'kadermoreprice'"
                                              :name="kader.value"
                                              :price="kader.price"
                                              :info="kader.info[$i18n.locale]"
                                              :current-value="currentValueKaderMorePrice.id"
                                              :value="kader"
                                              :id="kader.id"
                                              :imgSrc="kader.picture"
                                              @kaderOptie="setSelected">
                                    <p>
                                        {{kader.value}}<br>{{kader.info[$i18n.locale]}}
                                    </p>
                                </ext-checkbox>
                            </div>
                            <div v-if="orderedKaders.length == 0 && orderedKadersGratis.length == 0 && orderedKadersDefault.length == 0 ">
                                <p style="min-width: 500px">{{ $t('Geen kaders gevonden')}}</p>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>

        <div class="col-sm-3">
            <div class="your-selection col-sm-12">
                <div class="block title">
                    <p>{{ $t('Uw selectie')}}</p>
                </div>
                <div class="block">
                    <div class="prices">
                        <div class="line">
                            <div>{{StepOne.sku}}</div>
                            <div>&euro; {{StepOne.price}}</div>
                        </div>
                    </div>
                </div>

                <div class="block">
                        <div v-for="(price, key) in StepTwo">
                            <div v-if="key === 'mechanisme'">
                                <b>{{ $t('Mechanisme')}}</b><br>
                                <div div class="info">{{price.mectype}}&nbsp;{{price.mectrans[$i18n.locale]}}</div>
                            </div>
                        </div>
                    <div>&nbsp;</div>
                        <div v-for="(price, key) in StepTwo">
                            <div v-if="key === 'variant'">
                                <b>{{ $t('Variant')}}</b><br>
                                <div class="info">{{price.code}}&nbsp;{{price.name}}</div>
                                <div>&euro; {{price.price}}</div>
                            </div>
                        </div>
                    <div>&nbsp;</div>
                        <div v-for="(price, key) in StepTwo">
                            <div v-if="key === 'option'">
                                <p>{{ $t('Option')}}</p>
                                <div class="info">{{price.code}}&nbsp;{{price.parent}}</div>
                                <div>&euro; {{price.price}}</div>
                            </div>
                        </div>

                    </div>
                <div class="block">
                    <p>{{ $t('Opties en kaders')}}</p>
                    <div  v-for="price in prices">
                        <div v-if="price.type === 'optie'">
                            <div class="info">{{price.name}}&nbsp;{{price.info}}</div>
                            <div>&euro; {{price.price}}</div>
                        </div>
                    </div>
                    <div>&nbsp;</div>
                    <div  v-for="price in prices">
                        <div v-if="price.type !== 'optie' && price.type === 'kaderdefault'">
                            <div class="info">{{price.name}}&nbsp;{{price.info}} </div>
                            <div>&euro; {{price.price}}</div>
                        </div>
                    </div>
                    <div  v-for="price in prices">
                        <div v-if="price.type !== 'optie' && price.type === 'kadergratis'">
                            <div class="info">{{price.name}}&nbsp;{{price.info}}</div>
                            <div>&euro; {{price.price}}</div>
                        </div>
                    </div>
                    <div  v-for="price in prices">
                        <div v-if="price.type !== 'optie' && price.type === 'kadermoreprice'">
                            <div class="info">{{price.name}}&nbsp;{{price.info}}</div>
                            <div> &euro;  {{price.price}}</div>
                        </div>
                    </div>
                </div>
                <div class="block total">
                    <p>{{ $t('Totaal configuratie')}}</p>
                    <p>&euro; {{total}}</p>
                </div>
                <div class="block">
                  <p class="font-weight-normal">{{ $t('prijs_informatie')}}</p>
                  <p class="font-weight-normal">{{ $t('prijs_informatie2')}}</p>
                </div>
                <router-link to="/stepfour">
                    <button class="btn primary icon check">
                        {{ $t('OK, toon resultaat')}}
                    </button>
                </router-link>
                </div>

            </div>
        </div>
</template>

<script>
    import ExtCheckbox from '../components/elements/ExtCheckbox'
    import { EventBus} from '../services/eventBus'
    import apiService from '../services/request'
    import Vue from 'vue'
    import VueLodash from 'vue-lodash'

    export default {
        name: 'StepThree',
        components: {
            'ext-checkbox': ExtCheckbox
        },
        data () {
            return {
                StepOne: '',
                StepTwo: [],
                total: 0,
                totalKadersOptions: 0,
                opties: [],
                optie: [],
                kaders: [],
                kadersgratis: [],
                kadersdefaults: [],
                kader: [],
                prices: [],
                currentValueOption: {},
                currentValueKaderDefault: {},
                currentValueKaderGratis: {},
                currentValueKaderMorePrice: {},
                dataRadios: {
                    'alleAfmetingen24V': [
                        {
                            'value': 'Stecker (ONE 24 FDCU)'
                        },
                        {
                            'value': 'Unipolaire schakelaar (ONE 24 FDCU)'
                        },
                        {
                            'value': 'Bipolaire schakelaar (ONE 24 FDCU)'
                        }
                    ],
                    'kleinereAfmetingen24V': [
                        {
                            'value': 'Stecker (ONE 24 FDCU)'
                        },
                        {
                            'value': 'Thermische zekering (ONE 24 FDCU)'
                        }
                    ],
                    'alleAfmetingen230V': [
                        {
                            'value': 'Stecker (ONE 24 FDCU)'
                        },
                        {
                            'value': 'Unipolaire schakelaar (ONE 24 FDCU)'
                        },
                        {
                            'value': 'Bipolaire schakelaar (ONE 24 FDCU)'
                        }
                    ],
                    'kleinereAfmetingen230V': [
                        {
                            'value': 'Stecker (ONE 24 FDCU)'
                        },
                        {
                            'value': 'Thermische zekering (ONE 24 FDCU)'
                        }
                    ],
                    'alleAfmetingenOpties': [
                        {
                            'value': 'IXI-R1',
                            'text': 'Universele veldcontroller (Modbus, BACnet of analoge aansluiting), voorgemonteerd op de klep.',
                            'price': '213,20'
                        },
                        {
                            'value': 'IXI-R2 24V',
                            'text': 'Universele veldcontroller (Modbus, BACnet), voorgemonteerd op de klep, met aansluiting voor een 2de brandklep.',
                            'price': '213,20'

                        },
                        {
                            'value': 'IXI-R2 230V',
                            'text': 'Universele veldcontroller (Modbus, BACnet), voorgemonteerd op de klep, met aansluiting voor een 2de brandklep.',
                            'price': '213,20'
                        }
                    ],
                }
            }
        },
        methods: {
            setOption (selected) {

            },
            setSelected (object) {
                //console.log(object)
                let objectRemoved = false;
                for (var i = 0; i < this.prices.length; i++) {
                    if (this.prices[i].name == object.name) {
                        objectRemoved = true;
                        this.prices.splice(i,1)
                        this.getTotalKadersOptions()
                        this.getTotal()
                    }
                }


                if (!objectRemoved) {
                    this.prices.push(object)
                    this.getTotalKadersOptions()
                    this.getTotal()
                }

                Vue.ls.set('StepThree', this.prices)

            },
            getOptions () {
                apiService.getOptions(this.StepOne.id, 'nl-be' , this.setOptions)
            },
            setOptions (response) {

                /*this.StepOne.hoogte;
                this.StepOne.diameter;*/
                for (let key in response) {
                    //for (let i = 0; i < this.prices.length; i++) {
                    if (response[key].extra == 1) {
                        this.opties.push(response[key])
                    } else {
                        if (this.StepOne.diameter != '' && this.StepOne.diameter > 0) {
                            if (response[key].diameter == this.StepOne.diameter) {
                                this.opties.push(response[key])
                            }
                        } else {
                            if (response[key].breedte == this.StepOne.breedte && response[key].hoogte == this.StepOne.hoogte) {
                                this.opties.push(response[key])
                            }
                        }
                    }
                }
            },
            getKaders () {
                apiService.getKaders(this.StepOne.id, 'nl-be' , this.setKaders)
            },
            setKaders (response) {
                let specialMechs = ['CU-LT', 'CU-LT-L500', 'CU-LT-1s'];
                let specialMechsI = ['CU2', 'CU2L', 'CA2L', 'CA4L', 'CU2-15'];
                let measurements = { 200: { 100: 100, 125:125, 160:160}, 250: { 200: 200 }, 300: {250:250},
                350: {315:315}, 400:{355:355}, 450: {400:400}, 500:{450:450}, 550: {500:500}, 600:{600:600}
                }
                let measurementsI = { 200: { 100: 100, 125:125, 160:160,200:200}, 250: { 250: 250 }, 350: {315:315},
                    400: {355:355, 400:400}, 450:{450:450}, 500: {500:500}, 600:{600:600}, 650: {630:630}, 750:{710:710},
                    800:{800:800}, 900:{900:900}, 1000:{1000:1000}
                }
                let erpCode = this.StepOne.erpCode
                let breedte = this.StepOne.breedte
                let hoogte = this.StepOne.hoogte
                let diameter = this.StepOne.diameter
                console.log(response)
                for (let key in response) {
                    if (response[key].value ===  'PRJ') {
                        if (specialMechs.includes(erpCode)) {
                            if (breedte === hoogte) {
                                if (breedte in measurements) {
                                    for (let keyi in measurements[breedte]) {
                                        if (response[key].diameter == measurements[breedte][keyi]) {
                                            if (response[key].value ===  'PRJ' && key === 'PRJ' + measurements[breedte][keyi]) {
                                                response[key].value += '' + response[key].diameter
                                                this.kaders.push(response[key])
                                            }
                                        }
                                    }
                                }
                            }
                        } else if(specialMechsI.includes(erpCode)) {
                            if (breedte === hoogte) {
                                if (breedte in measurementsI) {
                                    for (let keyi in measurementsI[breedte]) {
                                        if (response[key].diameter == measurementsI[breedte][keyi]) {
                                            if (response[key].value ===  'PRJ' && key === 'PRJ' + measurementsI[breedte][keyi]) {
                                                response[key].value += '' + response[key].diameter
                                                this.kaders.push(response[key])
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    } else { // normal flow
                        if (response[key].price == 0) {
                            if (response[key].default) { //kader is recommended
                                this.kadersdefaults.push(response[key])
                            } else { //if not recommended is gratis
                                this.kadersgratis.push(response[key])
                            }
                        } else {
                            if (diameter != '' && diameter > 0) {
                                if (response[key].diameter == diameter) {
                                    if (response[key].default) {// is recommended
                                        this.kadersdefaults.push(response[key])
                                    } else { //kaders have meerprijs
                                        this.kaders.push(response[key])
                                    }
                                }
                            } else {
                                if (response[key].breedte == breedte && response[key].hoogte == hoogte) {
                                    if (response[key].default) {// is recommended
                                        this.kadersdefaults.push(response[key])
                                    } else { //kaders have meerprijs
                                        this.kaders.push(response[key])
                                    }
                                }
                            }
                        }
                    }
                }
            },
            getTotalKadersOptions () {
                let stepThree = 0;
                for (let key in this.prices) {
                    //for (let i = 0; i < this.prices.length; i++) {
                    // console.log(this.prices[i].value);
                    let price = this.prices[key].value;
                    let total = stepThree;
                    // stepThree = (+total + +price)
                    stepThree = Math.round((+total + +price) * 1e12) / 1e12
                }
                this.totalKadersOptions = Math.round((+stepThree) * 1e12) / 1e12;
            },
            getTotal () {
                let stepThree = 0;
                for (let key in this.prices) {
                    //for (let i = 0; i < this.prices.length; i++) {
                    // console.log(this.prices[i].value);
                    let price = this.prices[key].price;
                    let total = stepThree;
                    // stepThree = (+total + +price)
                    stepThree = Math.round((+total + price) * 1e12) / 1e12
                }

                let stepTwo = 0;
                //let price = 0;
                for (var key in this.StepTwo) {
                    if(typeof(this.StepTwo[key].price) != "undefined" && this.StepTwo[key].price !== null) {
                        console.log('key ' + key)
                        console.log('price ' + this.StepTwo[key].price)
                        let price = this.StepTwo[key].price;
                        let total = stepTwo;
/*                        console.log('total 2 ' + total)
                        console.log('price 2 ' + price)*/
                        stepTwo = Math.round((+total + +price) * 1e12) / 1e12
                    }
/*                    let total = stepTwo;
                    console.log('total 2 ' + total)
                    console.log('price 2 ' + price)
                    stepTwo = Math.round((+total + +price) * 1e12) / 1e12*/
                }
/*                console.log('precios')
                console.log(this.StepOne.price)
                console.log(stepTwo)
                console.log(stepThree)*/

                this.total = Math.round((+stepTwo + +stepThree + this.StepOne.price) * 1e12) / 1e12;
            }
        },
        mounted: function () {
            //console.log('paso')
            //console.log(Vue.ls.get('StepTwo'))
            if (Vue.ls.get('StepThree') !== null) {
                let optionsObj = Vue.ls.get('StepThree')
                //console.log(optionsObj)
                //for (this.kadersdefaults )

                for (let j = 0; j < optionsObj.length; j++) {
                    if (optionsObj[j].type === 'optie') {
                        this.currentValueOption = optionsObj[j]
                    }
                    if (optionsObj[j].type === 'kadergratis') {
                        this.currentValueKaderGratis = optionsObj[j]
                    }
                    if (optionsObj[j].type === 'kadermoreprice') {
                        this.currentValueKaderMorePrice = optionsObj[j]
                    }
                    if (optionsObj[j].type === 'kaderdefault') {
                        this.currentValueKaderDefault = optionsObj[j]
                    }
                }


            }
            if(Vue.ls.get('StepTwo') === null) {
                this.$router.push({name: 'StepTwo'})
            }
            if(Vue.ls.get('StepOne') === null) {
                this.$router.push({name: 'StepOne'})
            }
            EventBus.$on('OptionSelected', this.setOption)
            EventBus.$emit('routeChange')
            this.StepOne = Vue.ls.get('StepOne');
            this.StepTwo = Vue.ls.get('StepTwo');
            this.getOptions()
            this.getKaders()
            this.getTotal()
            //Vue.ls.set('StepThree', [])
        },
        computed: {
            orderedOptions: function () {
                return _.orderBy(this.opties, 'sortsequence')
            },
            orderedKaders: function () {
                return _.orderBy(this.kaders, 'sortsequence')
            },
            orderedKadersGratis: function () {
                return _.orderBy(this.kadersgratis, 'sortsequence')
            },
            orderedKadersDefault: function () {
                return _.orderBy(this.kadersdefaults, 'sortsequence')
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/StepThree.vue